import React from 'react'
import { SupportContact } from './SupportContact'
import { SupportFeatures } from './SupportFeatures'
import { SupportFreeTrial } from './SupportFreeTrial'

export const SupportSection: React.FC = () => {
    return (
        <div className="flex px-4 py-10 justify-center bg-[#181818] rounded-t-3xl">
            <div className="flex flex-col w-full lg:w-[940px] gap-4 items-center">
                <SupportFeatures />
                <SupportFreeTrial />
                <SupportContact />
            </div>
        </div>
    )
}
